import { GameSettings } from "./types";
import { contentTypeIds } from "../types";

export const hayday: GameSettings = {
  enabledTabs: ["news", "community", "blog"],
  enabledLocales: [
    "ar",
    "da",
    "de",
    "en",
    "es",
    "fi",
    "fr",
    "id",
    "it",
    "ja",
    "ko",
    "ms",
    "nl",
    "pt",
    "ru",
    "th",
    "tr",
    "vi",
    "zh",
    "zh-hans",
  ],
  referenceWidth: 1064,
  enabledNotificationTypes: ["standard"],
  availableButtonVariants: ["green", "orange", "blue", "twitch"],
  progressBarDefaultColor: "#f9b717",
  availableCategories: [
    {
      id: "news",
      name: {
        en: "News",
        ar: "أخبار",
        da: "Nyheder",
        de: "Neues",
        es: "Noticias",
        fi: "Uutiset",
        fr: "Nouvelles",
        id: "Promosi",
        it: "Notizie",
        ja: "ニュース",
        ko: "뉴스",
        ms: "Berita",
        nl: "Nieuws",
        pt: "Notícias",
        ru: "Новости",
        th: "ข่าว",
        tr: "Haberler",
        vi: "Tin tức",
        zh: "最新情報",
        "zh-hans": "新闻",
      },
      color: "#3884b8",
    },
    {
      id: "game-updates",
      name: {
        en: "Game Updates",
        ar: "تحديثات اللعبة",
        da: "Spilopdateringer",
        de: "Updates",
        es: "Novedades",
        fi: "Julkaisutiedot",
        fr: "Mises à jour",
        id: "Pembaruan Game",
        it: "Aggiornamenti di gioco",
        ja: "アップデート",
        ko: "게임 업데이트",
        ms: "Kemas Kini",
        nl: "Spelupdates",
        pt: "Novidades do jogo",
        ru: "Обновления",
        th: "อัปเดตเกม",
        tr: "Oyun Güncellemeleri",
        vi: "Cập nhật trò chơi",
        zh: "遊戲更新",
        "zh-hans": "游戏更新",
      },
      color: "#8ed44b",
    },
    {
      id: "fan-art",
      name: {
        en: "Fan Art",
        ar: "إبداعات الجمهور",
        da: "Bidrag fra fans",
        de: "Fankunst",
        es: "Fan Art",
        fi: "Fanitaide",
        fr: "Fan art",
        id: "Seni Buatan Penggemar",
        it: "Fan art",
        ja: "ファンアート",
        ko: "팬아트",
        ms: "Seni Peminat",
        nl: "Fankunst",
        pt: "Arte dos fãs",
        ru: "Фан-арт",
        th: "แฟนอาร์ท",
        tr: "Fan Çizimi",
        vi: "Tranh do người hâm mộ vẽ",
        zh: "玩家作品",
        "zh-hans": "同人作品",
      },
      color: "#de5452",
    },
    {
      id: "community",
      name: {
        en: "Community",
        ar: "المجتمع",
        da: "Fællesskab",
        de: "Community",
        es: "Comunidad",
        fi: "Yhteisö",
        fr: "Communauté",
        id: "Komunitas",
        it: "Community",
        ja: "コミュニティ",
        ko: "커뮤니티",
        ms: "Komuniti",
        nl: "Community",
        pt: "Comunidade",
        ru: "Сообщество",
        th: "ชุมชน",
        tr: "Topluluk",
        vi: "Cộng đồng",
        zh: "社群",
        "zh-hans": "社区",
      },
      color: "#d273fa",
    },
    {
      id: "events",
      name: {
        en: "Events",
        ar: "أحداث",
        da: "Begivenheder",
        de: "Ereignisse",
        es: "Eventos",
        fi: "Tapahtumat",
        fr: "Événements",
        id: "Acara",
        it: "Eventi",
        ja: "イベント",
        ko: "이벤트",
        ms: "Acara",
        nl: "Evenementen",
        pt: "Eventos",
        ru: "События",
        th: "อีเวนท์",
        tr: "Etkinlikler",
        vi: "Sự kiện",
        zh: "活動",
        "zh-hans": "常规活动",
      },
      color: "#ff5450",
    },
    {
      id: "derby",
      name: {
        en: "Derby",
        ar: "Derby",
        da: "Derby",
        de: "Derby",
        es: "Derby",
        fi: "Derby",
        fr: "Derby",
        id: "Derby",
        it: "Derby",
        ja: "Derby",
        ko: "Derby",
        ms: "Derby",
        nl: "Derby",
        pt: "Derby",
        ru: "Derby",
        th: "Derby",
        tr: "Derby",
        vi: "Derby",
        zh: "Derby",
        "zh-hans": "Derby",
      },
      color: "#e0a24f",
    },
    {
      id: "campaign",
      name: {
        en: "Campaign",
        ar: "الحملة",
        da: "Kampagne",
        de: "Spezialaktion",
        es: "Promociones",
        fi: "Kampanja",
        fr: "Campagne",
        id: "Promosi",
        it: "Promozioni",
        ja: "キャンペーン",
        ko: "프로모션",
        ms: "Kempen",
        nl: "Campagne",
        pt: "Promoções",
        ru: "Кампания",
        th: "แคมเปญ",
        tr: "Kampanya",
        vi: "Khuyến mãi",
        zh: "活動",
        "zh-hans": "推广活动",
      },
      color: "#ff80c0",
    },
    {
      id: "beta-testing",
      name: {
        en: "Beta Testing",
      },
      color: "#6B552F",
    },
    {
      id: "team-letter",
      name: {
        // Locale strings pending
        en: "Letter from the Hay Day team",
      },
      color: "#2F2F2F",
    },
  ],

  enabledComposePages: ["news", "events"],

  resolutions: {
    [contentTypeIds.newsEntryExternalLink]: {
      linkThumbnail: {
        width: 900,
        height: 506,
      },
    },

    [contentTypeIds.newsEntryImage]: {
      imageNewsThumbnail: {
        width: 900,
        height: 506,
      },
    },

    [contentTypeIds.newsEntryVideo]: {
      videoThumbnail: {
        width: 900,
        height: 506,
      },
    },

    [contentTypeIds.newsEntryArticle]: {
      heroImage: {
        width: 1950,
        height: 650,
      },
      largeThumbnail: {
        width: 900,
        height: 506,
      },

      websiteHeroImage: {
        width: 3000,
        height: 600,
      },
    },

    [contentTypeIds.smallNewsEntryArticle]: {
      heroImage: {
        width: 1950,
        height: 650,
      },
      smallThumbnail: {
        width: 880,
        height: 880,
      },
      websiteHeroImage: {
        width: 3000,
        height: 600,
      },
    },
    [contentTypeIds.smallNewsEntryExternalLink]: {
      linkThumbnail: {
        width: 880,
        height: 880,
      },
    },

    [contentTypeIds.videoBlock]: {
      videoThumbnail: {
        width: 960,
        height: 540,
      },
    },

    [contentTypeIds.imageBlock]: {
      image: null,
    },
    [contentTypeIds.featureBlock]: {
      featureThumbnail: {
        width: 700,
        height: 700,
      },
    },
    [contentTypeIds.pollBlock]: {
      option1Image: {
        width: 300,
        height: 400,
        fit: "pad",
      },
      option2Image: {
        width: 300,
        height: 400,
        fit: "pad",
      },
      option3Image: {
        width: 300,
        height: 400,
        fit: "pad",
      },
      option4Image: {
        width: 300,
        height: 400,
        fit: "pad",
      },
      option5Image: {
        width: 300,
        height: 400,
        fit: "pad",
      },
    },

    [contentTypeIds.carouselEventEntry]: {
      carouselImage: {
        width: 860,
        height: 1320,
      },
    },
    [contentTypeIds.carouselEventPollEntry]: {
      carouselImage: {
        width: 860,
        height: 1320,
        fit: "pad",
      },
      option1Image: {
        width: 300,
        height: 400,
        fit: "pad",
      },
      option2Image: {
        width: 300,
        height: 400,
        fit: "pad",
      },
      option3Image: {
        width: 300,
        height: 400,
        fit: "pad",
      },
      option4Image: {
        width: 300,
        height: 400,
        fit: "pad",
      },
      option5Image: {
        width: 300,
        height: 400,
        fit: "pad",
      },
    },
    [contentTypeIds.carouselEventProgressTrackerEntry]: {
      carouselImage: {
        width: 860,
        height: 1320,
      },
      milestone1Image: {
        width: 256,
        height: 256,
      },
      milestone2Image: {
        width: 256,
        height: 256,
      },
      milestone3Image: {
        width: 256,
        height: 256,
      },
      milestone4Image: {
        width: 256,
        height: 256,
      },
      milestone5Image: {
        width: 256,
        height: 256,
      },
      milestone6Image: {
        width: 256,
        height: 256,
      },
      milestone7Image: {
        width: 256,
        height: 256,
      },
      milestone8Image: {
        width: 256,
        height: 256,
      },
    },

    [contentTypeIds.communityCreator]: {
      communityCreatorThumbnail: {
        width: 50,
        height: 50,
      },
    },

    [contentTypeIds.communityVideoEntry]: {
      communityEntryVideoThumbnail: {
        width: 860,
        height: 482,
      },
    },

    [contentTypeIds.communityLivestreamEntry]: {
      livestreamEntryVideoThumbnail: {
        width: 860,
        height: 482,
      },
    },

    [contentTypeIds.localizedSpotlight]: {
      image: {
        width: 1280,
        height: 720,
      },
    },

    [contentTypeIds.localizedHero]: {
      image: {
        width: 1920,
        height: 720,
      },
    },

    [contentTypeIds.eventCalendarEntry]: {
      backgroundImage: {
        width: 1920,
        height: 720,
      },
    },

    [contentTypeIds.calendarEventEntry]: {
      image: {
        width: 800,
        height: 720,
      },
    },

    [contentTypeIds.calendarEventReward]: {
      image: {
        width: 256,
        height: 256,
      },
    },
  },

  activeContentInDays: {
    community: 90,
    news: 90,
  },

  supportSmallArticles: true,
  tabContentFallbacks: {
    community: {
      fi: ["en"],
      da: ["en"],
      ru: ["en"],
      fr: ["en"],
      id: ["en"],
      it: ["en"],
      ja: ["en"],
      ko: ["en"],
      ms: ["en"],
      th: ["en"],
      tr: ["en"],
      vi: ["en"],
      zh: ["en"],
      "zh-hans": ["en"],
    },
  },

  blogMeta: {
    site: "Hay Day",
    creator: "@hayday",
  },

  supportPolls: true,
  supportTargetPolls: false,
  supportProgressTrackerEntry: true,
  supportDisablingEventsOnMilestone: true,
  supercellMakeEnabled: true,
  gridEnabled: true,
  updatedBadgeEnabled: true,
  targetingFields: [
    "country",
    "countryExclude",
    "platform",
    "avatarIds",
    "campaignId",
  ],
};
